// src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

// Canonical base URL — always the www version to fix Google's duplicate-content warning.
// All canonical tags will resolve to: https://www.engdemyeducation.com/<path>
const SITE_URL = "https://www.engdemyeducation.com";

// Pages that are public and should have SEO
const seoData = {
    "/": {
        title: "CELPIP Preparation Online-Free CELPIP Practice Tests & Study Material",
        description: "Prepare for CELPIP with free study material, and practice exams online with mock tests, AI scoring, and tips. Boost your Reading, Writing, Listening, and Speaking skills.",
        keywords: "celpip practice test,celpip prpearation.celpip reading,celpip mock tests,celpip writing,celpip speaking. celpip test, celpip writing, celpip general test, celpip sample test, celpip speaking, celpip listening practice test, celpip test practice, celpip online test, celpip test online, celpip practice, celpip general, celpip listening, celpip practice test free, celpip reviewer, celpip free practice test, celpip listening practice, celpip free test, celpip preparation, celpip practice tests, celpip practice exam, writing celpip, celpip reading test, celpip english test, celpip reading, celpip test sample, celpip speaking test, celpip general test sample, celpip online classes, celpip speaking samples, celpip mock tests, celpip course online, free celpip practice test, celpip speaking questions, celpip writing practice, reading celpip, celpip test free practice, celpip mock test, celpip preparation course, reading celpip practice test, celpip writing test, celpip english test sample",
        canonical: `${SITE_URL}/`
    },
    "/course": {
        title: "CELPIP PreparationCourse - Online Test Preparation",
        description: "Best CELPIP preparaion course and online lessons to improve your Reading, Writing, Listening, and Speaking. Prepare effectively for CELPIP tests with our structured courses.",
        keywords: "celpip course online, celpip courses, online celpip preparation, celpip training, celpip lessons, celpip coaching, celpip coaching online, celpip training center near me",
        canonical: `${SITE_URL}/course`
    },
    "/practice": {
        title: "CELPIP Practice Tests - Free & Online",
        description: "Access free CELPIP practice tests, mock exams, and AI scoring. Improve your Reading, Writing, Listening, and Speaking skills for the CELPIP test.",
        keywords: "celpip practice test, celpip practice, celpip practice test free, celpip free practice test, free celpip practice test, celpip practice test online, celpip practice test with answers, practice celpip, celpip practice exams, celpip practice online, celpip practice reading test, celpip practice speaking",
        canonical: `${SITE_URL}/practice`
    },
    "/fulltest": {
        title: "CELPIP Full Tests - Mock & Online",
        description: "Take full CELPIP mock tests to evaluate your skills and readiness. Practice Reading, Writing, Listening, and Speaking sections online with scoring feedback.",
        keywords: "celpip full mock test, celpip mock tests, mock test celpip, free mock test for celpip, celpip test simulator, celpip online mock test, celpip simulation test",
        canonical: `${SITE_URL}/fulltest`
    },
    "/vocabulary": {
        title: "CELPIP Vocabulary Practice",
        description: "Boost your CELPIP vocabulary to improve Reading, Writing, Listening, and Speaking. Learn words, phrases, and practice exercises for CELPIP test success.",
        keywords: "celpip vocabulary, vocabulary for celpip, celpip learning materials, celpip practice material, celpip practise material",
        canonical: `${SITE_URL}/vocabulary`
    },
    "/about": {
        title: "About CELPIP Practice Platform",
        description: "Learn about our CELPIP preparation platform, mission, and services. Improve your English skills and test readiness with structured resources.",
        keywords: "celpip, about us, mission, services, celpip preparation, english test, celpip for canada, celpip canada",
        canonical: `${SITE_URL}/about`
    },
    "/contact": {
        title: "Contact CELPIP Support",
        description: "Reach out for CELPIP test preparation queries, support, and feedback. Get help for Reading, Writing, Listening, and Speaking practice.",
        keywords: "celpip contact, celpip support, celpip queries, celpip feedback, celpip help",
        canonical: `${SITE_URL}/contact`
    },

    "/terms": {
        title: "Terms & Conditions - CELPIP Portal",
        description: "Read the terms and conditions for using our CELPIP test preparation platform.",
        keywords: "terms and conditions, CELPIP, website usage, policies",
        canonical: `${SITE_URL}/terms`
    }
};

// Generic SEO for login / dashboard / user-specific pages
const genericSEO = {
    title: "CELPIP Practice Portal",
    description: "Access CELPIP practice tests, track your progress, and improve your English skills online.",
    keywords: "celpip, celpip practice, celpip online test, celpip test preparation"
};

const SEO = ({ page }) => {
    const { title, description, keywords, canonical } = seoData[page] || genericSEO;

    // Build a fallback canonical from the current path if not explicitly defined
    const canonicalUrl = canonical || `${SITE_URL}${page}`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            {/* Canonical tag — tells Google the authoritative URL for this page.
                Always points to the www version to fix the www vs non-www duplicate issue. */}
            <link rel="canonical" href={canonicalUrl} />
        </Helmet>
    );
};

export default SEO;

